/**
 * @param callback function
 * @param purpose integer
 * @param tcData string
 * @param listenerSuccess boolean
 * @returns if window.__tcfapi is available, useractioncomplete or tcloaded events are listened for.
 * Once fired the returned @param tcData is queried for @param purpose value of true.
 * @param callback if @param purpose returns true as consent has been granted.
 */
var waitForConsent = function waitForConsent(callback) {
  var purpose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  /* istanbul ignore next */
  if (!window.__tcfapi) {
    var error = new Error('window.__tcfapi not found');
    console.error(error);
  }

  window.__tcfapi('addEventListener', 2, function (tcData, listenerSuccess) {
    if (!listenerSuccess) {
      var _error = new Error('addEventListener failure in TCFAPI');

      console.error(_error);
      return;
    }

    if (['useractioncomplete', 'tcloaded'].includes(tcData.eventStatus) && tcData.purpose.consents[purpose]) {
      callback(); // Remove the event listener to avoid calling every time the consent
      // string changes.

      window.__tcfapi('removeEventListener', 2, function (removeSuccess) {
        if (!removeSuccess) {
          var _error2 = new Error('removeEventListener failure in TCFAPI');

          console.error(_error2);
        }
      }, tcData.listenerId);
    }
  });
};

export { waitForConsent };